import React from 'react';

interface SelectOption {
  value: string;
  label: string;
}

interface SelectInputProps {
  value: string;
  onChange: (value: string) => void;
  options: readonly SelectOption[] | SelectOption[];
  placeholder?: string;
  error?: boolean;
  disabled?: boolean;
  className?: string;
}

export function SelectInput({
  value,
  onChange,
  options,
  placeholder = '— Select —',
  error = false,
  disabled = false,
  className = '',
}: SelectInputProps) {
  const baseClasses =
    'w-full px-3 py-2.5 rounded-lg bg-white border text-[#1D314D] focus:ring-2 focus:ring-[#CEAB65]/50 focus:border-[#CEAB65] transition duration-150';
  const errorClasses = error ? 'border-red-500' : 'border-slate-300';
  const disabledClasses = disabled ? 'opacity-50 cursor-not-allowed bg-slate-50' : '';

  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      className={`${baseClasses} ${errorClasses} ${disabledClasses} ${className}`}
    >
      <option value="" className="text-slate-400">{placeholder}</option>
      {options.map((option) => (
        <option key={option.value} value={option.value} className="text-[#1D314D]">
          {option.label}
        </option>
      ))}
    </select>
  );
}
